import { theme } from "style";
export default theme;
